import { AiModalState, CurrentConversationType } from "./aiContext";

export type AiUsageType = {
    top: number;
    left: number;
    modalState: AiModalState;
    modalOpen: boolean;
    currentConversationId: number;
};

export class CookieHelper {
    static setCookie(name: string, value: string, days: number, onlyStoreInSession: boolean = false): void {
        if (typeof value === "string") {
            const encodedValue = btoa(encodeURIComponent(value)); // Encode the value
            let expires = "";
    
            if (onlyStoreInSession) {
                // No expires attribute means the cookie will be stored only for the current session
                expires = "";
            } else if (days === Infinity) {
                // Set the expiration date to a far future date for indefinite storage
                const date = new Date();
                date.setFullYear(date.getFullYear() + 100); // 100 years in the future
                expires = "expires=" + date.toUTCString();
            } else {
                const date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "expires=" + date.toUTCString();
            }
            document.cookie = `${name}=${encodedValue};${expires};path=/`;
        } else {
            console.warn("setCookie: Unable to store cookie: Got bad Value:", value);
        }
    }

    static getCookie(name: string): string | null {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                const encodedValue = c.substring(nameEQ.length, c.length);
                return decodeURIComponent(atob(encodedValue)); // Decode the value
            }
        }
        return null;
    }

    static deleteCookie(name: string): void {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }

    static createOrUpdateAiUsage(aiUsage: AiUsageType, days: number): void {
        const jsonValue = JSON.stringify(aiUsage);
        this.setCookie('aiUsage', jsonValue, days);
    }

    static readAiUsage(): AiUsageType | null {
        try {
            const jsonValue = this.getCookie('aiUsage');
            if (!!jsonValue) {
                return JSON.parse(jsonValue) as AiUsageType;
            }
            return null;
        } catch (e) {
            console.error(e);
            return null;
        }
    }

    static deleteAiUsage(): void {
        this.deleteCookie('aiUsage');
    }
}